<script setup lang="ts">
import { PropType } from "vue";
import MenuContent from "./MenuContent.vue";
import Category from "../model/category";

const props = defineProps({
  category: {
    type: Object as PropType<Category>,
    required: true,
  }
});

</script>

<template>
  <!-- Menu desktop épuré -->
  <div
    class="
      xl:sticky
      xl:top-20
      xl:right-0
      xl:w-3/12
      xl:float-right
      xl:h-auto
      xl:pt-6
      hidden
      xl:block
    "
  >
    <div class="
        bg-white
        dark:bg-gray-800
        border
        border-gray-200
        dark:border-gray-700
        rounded-lg
        shadow-sm
        p-4
        sticky-nav-menu
      ">
      <!-- En-tête du menu -->
      <h3 class="
          text-sm
          font-semibold
          text-gray-900
          dark:text-gray-100
          mb-3
          pb-2
          border-b
          border-gray-200
          dark:border-gray-700
        ">
        Navigation rapide
      </h3>

      <!-- Contenu du menu avec sections collapsibles -->
      <div class="
          max-h-[calc(100vh-200px)]
          overflow-y-auto
          pr-1
          custom-scrollbar
          space-y-1
        ">
        <MenuContent v-if="props.category" :marker="props.category.d" slug="d" />
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Scrollbar discrète */
.custom-scrollbar::-webkit-scrollbar {
  width: 4px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgb(203, 213, 225);
  border-radius: 2px;
}

.dark .custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgb(75, 85, 99);
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgb(148, 163, 184);
}

.dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgb(100, 116, 139);
}
</style>
